/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientTargetDataModel } from '../../models/patient-target-data-model';

export interface GetPatientTargetData$Params {
  patientSessionID?: number;
}

export function GetPatientTargetData(http: HttpClient, rootUrl: string, params?: GetPatientTargetData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientTargetDataModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientTargetData.PATH, 'get');
  if (params) {
    rb.query('patientSessionID', params.patientSessionID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientTargetDataModel>>;
    })
  );
}

GetPatientTargetData.PATH = '/api/Staff/GetPatientTargetData';
